import * as v from 'valibot';
import Ajax from '../util/ajax';
import { panelDeviceAdded } from '../features/panel_devices/panelDevicesSlice';
import { hideDialog } from '../reducers/app';
import { panelTransmitterSchema } from '../types/PanelTransmitter';
export function createPanelTransmitter(panel_id) {
    return (dispatch, getState) => {
        const { edit_panel_transmitter_dialog } = getState();
        const ajax = new Ajax(dispatch);
        const url = '/panel/' + panel_id + '/transmitter/create';
        const obj = {
            transmitter_id: edit_panel_transmitter_dialog.device_id,
            panel_group_id: edit_panel_transmitter_dialog.panel_group_id,
            ord: edit_panel_transmitter_dialog.ord
        };
        ajax.post(url, obj, data => {
            const res = v.safeParse(panelTransmitterSchema, data);
            if (res.success) {
                const panelTransmitter = res.output;
                const panelDevice = {
                    id: panelTransmitter.id,
                    panel_group_id: panelTransmitter.panel_group_id,
                    device_id: panelTransmitter.transmitter_id,
                    ord: panelTransmitter.ord
                };
                dispatch(panelDeviceAdded(panelDevice));
            }
            else {
                console.error(v.summarize(res.issues));
            }
            dispatch(hideDialog());
        });
    };
}
